import { featureCollection } from '@turf/turf';
import ChubbyMarker from './chubby_marker';
import CircleMarker from './circle_marker';
import RingMarker from './ring_marker';
import StandardMarker from './standard_marker';

export default class MapMarkerSet {
  SHAPES = {
    "chubby": ChubbyMarker,
    "circle": CircleMarker,
    "ring": RingMarker,
    "standard": StandardMarker
  };

  constructor(pointFeatures, options) {
    this.markers = pointFeatures.map((point) => {
      return new this.SHAPES[options.style.shape](point, options);
    });
    this.map = options.map;
    this.assets = options.assets;
    this.style = options.style;
    this.shown = false;
    if (options.pointFeatureSet.labels.enabled) {
      this.map.addSource('pointLabels', {
        'type': 'geojson',
        'data': featureCollection(pointFeatures)
      });
    }
  }

  hide() {
    if (this.map.getLayer('poi-labels')) this.map.removeLayer('poi-labels');

    this.markers.forEach(marker => marker.hide());
    this.shown = false;
  }

  show() {
    if (this.map.getSource('pointLabels')) {
      this.map.addLayer({
        'id': 'poi-labels',
        'type': 'symbol',
        'source': 'pointLabels',
        'layout': {
          'text-field': ['get', 'title'],
          'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
          'text-radial-offset': this._textRadialOffset(),
          'text-justify': 'auto',
        },
        'paint': {
          'text-color': '#202',
          'text-halo-width': 2,
          'text-halo-color': "#fff"
        }
      });
    }
    this.markers.forEach(marker => marker.show());
    this.shown = true;
  }

  toggle() {
    if (this.shown) {
      this.hide();
      this.shown = false;
    }
    else {
      this.show();
      this.shown = true;
    }
  }

  remove() {
    this.hide();
    if (this.map.getSource('pointLabels')) this.map.removeSource('pointLabels');
  }

  _textRadialOffset() {
    switch(this.style.shape) {
    case "circle":
    case "ring":
      return 1;
    default:
      return 0.1;
    }
  }
}
